export default __webpack_public_path__ + "locales/ar-SA/PreparationPortal.json?hash=66960135f502511ecc8e46eb783dbefa";